import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import SummaryTable from "../../Components/Vendor/SummaryTable";
import ViewDetails from "../../Components/Vendor/ViewDetails";
import DateRange from "../../Components/DateRange";
import moment from "moment";
import SideModal from "../../Components/SideModal";
import { IoChevronBackOutline } from "react-icons/io5";

const VendorExpenseList = () => {
    const navigate = useNavigate();
  const { vendorId } = useParams();
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isViewExpense, setIsViewExpense] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(6, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const query = `&startDate=${startDate}&endDate=${endDate}&vendorId=${vendorId}`;

  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/vendor/list/expense/web?${query}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res);
      setIsFocused(true);
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  // useEffect(() => {
  //   getListMutate();
  // }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    const handler = setTimeout(() => {
      getListMutate();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  };

  return (
    <BoxContainer>
      <BoxHead>
        {/* <BoxTitle className="!mb-0 whitespace-nowrap">
          Vendor Summary
          <Underline />
        </BoxTitle> */}
         <BoxTitle className="!mb-0 whitespace-nowrap">
                    <div className="flex" onClick={() => navigate(-1)}>
                      <span className="hover:bg-gray-200 items-center pt-[5px]">
                        <IoChevronBackOutline
                          size={20}
                          //className="text-primary-color"
                        />
                      </span>
                      <div>
                        <span className="flex items-center cursor-pointer">
                          Vendor Summary
                        </span>
                        <Underline />
                      </div>
                    </div>
                  </BoxTitle>
        <DateRange
          submitHandler={submitHandler}
          defaultLabel={
            moment(startDate).format("DD MMM yyyy") +
            " - " +
            moment(endDate).format("DD MMM yyyy")
          }
        />
      </BoxHead>
      
             <SideModal
              isOpen={isViewExpense}
              onClose={() => setIsViewExpense(false)}
            >
          <ViewDetails
            setIsViewExpense={setIsViewExpense}
            selectedData={selectedData}
          />
          </SideModal>
       
      {!error && !isLoading && data && (
        <TableWrapper>
          <SummaryTable
            apiData={apiData.expenseList || []}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            setIsViewExpense={setIsViewExpense}
          />
          {(!apiData || apiData.expenseList === false) && <NotFoundModel />}
        </TableWrapper>
      )}

      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`my-8 border bg-white rounded-md`;
const FilterWrapper = tw.div`flex w-full pt-8 lg:flex-row flex-col lg:gap-0 gap-4`;
export default VendorExpenseList;
